import { Typography } from "@mui/material";
import { CenteredContent } from "../components/layout/CenteredContent";

export function PageNotFound() {
    return (
        <CenteredContent>
            <Typography variant="h1">Not found 404</Typography>
        </CenteredContent>

    )
}